import styled from 'styled-components';
import {COLORS, SIZES} from '@fupa/fupa-uikit';

// Header

const Header = styled.div`
  display: flex;
  align-items: center;
  height: ${SIZES['36']};
  padding: 0 ${SIZES['16']};
  background-color: ${COLORS.white};
`;

const Stat = styled.div<{align: string; minWidth: number; setMaxWidth?: boolean; conditional?: boolean}>`
  text-align: ${props => props.align};
  flex: 1 15%;
  min-width: ${props => SIZES[props.minWidth]};
  ${props =>
    props.setMaxWidth &&
    `
     max-width: 3rem;
  `};
  ${props =>
    props.conditional &&
    `
  @media only screen and (max-width: 479px) {
    display: none;
  }
  `}
`;

const RankStat = styled(Stat)`
  &&& {
    flex: 1 5%;
  }
`;

const Team = styled.div`
  display: flex;
  flex: 1 40%;
  white-space: nowrap;
  overflow: hidden;
`;

const TeamImage = styled(Stat)`
  display: flex;
  justify-content: center;
  min-width: ${SIZES['32']};
  margin-right: ${SIZES['12']};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 100%;
  width: 100%;
  background-color: ${COLORS.white};
`;

type Marks = 'up1' | 'up2' | 'up3' | 'down1' | 'down2';

const marks = {
  up1: COLORS.lightGrey,
  up2: COLORS.lighterGrey,
  up3: COLORS.lightestGrey,
  down1: COLORS.lighterGrey,
  down2: COLORS.lightGrey,
};

const Container = styled.div<{live?: boolean; height?: number; mark?: Marks}>`
  display: flex;
  align-items: center;
  padding-left: ${props => (props.live ? SIZES['12'] : SIZES['16'])};
  padding-right: ${SIZES['16']};
  height: ${props => (props.height ? SIZES[props.height] : SIZES['36'])};
  background-color: ${props => (props.mark && props.mark in marks ? marks[props.mark] : COLORS.white)};
  border-left: ${SIZES['4']} solid ${props => (props.live ? COLORS.fupaSecondary : 'none')};
  line-height: ${SIZES['16']};
`;

export {Header, Stat, RankStat, Team, TeamImage, Content, Container};
